export default "__VITE_ASSET__D2TseUgv__"